import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SeniorLivingLandingPage } from './pages/SeniorLivingLandingPage';
import { ThankYou } from './pages/ThankYou';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3k8jj5k0fz6p6">
      <Routes data-id="element-1" data-mp="3k92qk6sgucoy">
        <Route path="/" element={<SeniorLivingLandingPage data-id="element-3" data-mp="3fahwyq7pyr9h" />} data-id="element-2" data-mp="3k7i4l5k7w22p" />
        <Route path="/thank-you" element={<ThankYou data-id="element-5" data-mp="3f8ez5k0brtu7" />} data-id="element-4" data-mp="3fbj8swwk7hs9" />
      </Routes>
    </BrowserRouter>;
}